
// used for local development.
class LocalDataFetcher {

    constructor(path) {
        this.dataPath = path === undefined ? "/test/local_data.json" : path;
    }

    getData() {
        return fetch(this.dataPath).then(res => {
            return res.json();
        });
    }
}

export default LocalDataFetcher;


// WEBPACK FOOTER //
// ./src/LocalDataFetcher.js